import { usePatchConclusionMutation } from "../conclusionsSlice";

const usePatchRules = () => {
  const [mutation, mutationProps] = usePatchConclusionMutation();

  const modifiedMutation = async ({ body, params }) => {
    const grouped = {};

    for (const key in body) {
      const [parameter, index, type] = key.split("___");
      if (!grouped[parameter]) grouped[parameter] = {};
      if (!grouped[parameter][index]) grouped[parameter][index] = {};
      grouped[parameter][index][type] = body[key];
    }

    const rules = [];
    for (const parameter in grouped) {
      for (const index in grouped[parameter]) {
        const entry = grouped[parameter][index];
        rules.push({
          parameter,
          operator: {
            [entry.operator]: entry.operatorValue,
          },
        });
      }
    }
    return mutation({ body: { rules }, params });
  };

  return [modifiedMutation, mutationProps];
};

export default usePatchRules;
